import qs from 'qs';
import appConfig from '@/config';
import {InternalAxiosRequestConfig} from 'axios';

/**
 * Sphere BE axios instance for the product catalogue API wrapper
 */

/**
 * User management Axios instance
 */
const userManagementAxiosInstance = createAxiosInstance({
  paramsSerializer: {
    serialize: (params: any) => qs.stringify(params, {encode: false}),
  },
});

/**
 * Interceptor used by each User management Axios instance
 */
userManagementAxiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig<any>) => {
    config.baseURL = `${appConfig.BACKEND_API}product-catalogue/api`;

    const userStore = useUserStore();
    if (userStore.msalToken !== null && userStore.msalToken.accessToken) {
      config.headers.Authorization = `Bearer ${userStore.msalToken.accessToken}`;
    }
    return config;
  },
  (error: unknown) => Promise.reject(error),
);

export {userManagementAxiosInstance};
